import "./Dropdown.css";
import { useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
// import logo from "../../assets/dropdown/edit.png";
import { useNavigate } from "react-router-dom";
import { FULL_API_BASE_URL } from "../../../../Config/Config";

function Dropdown({ setAuthenticated, setPagePath, setIsLoggedOut }) {
  const navigate = useNavigate();
  const { data } = useSelector((state) => state.landing);
  const gender_id = data ? `${data.client_schema_name[6][0].gender_id}` : "";
  // const gender_id = 2;
  // console.log("gender", gender_id);

  const [open, setOpen] = useState(false);
  let menuRef = useRef();

  useEffect(() => {
    let handler = (e) => {
      if (!menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  const handleSelect = (branch) => {
    // setSelectedBranch(branch);
    setOpen(false);
  };

  // const handleLogout = () => {
  //   // setAuthenticated(false);
  //   // localStorage.removeItem("isLoggedIn");
  //   setAuthenticated(false);
  //   localStorage.removeItem("isLoggedIn");
  //   localStorage.removeItem("userId");
  //   localStorage.removeItem("clientId");
  //   sessionStorage.removeItem("isLoggedIn");
  //   sessionStorage.removeItem("userId");
  //   sessionStorage.removeItem("clientId");

  //    // Reset pagePath to "home"
  //   //  setPagePath("Home");
  //    localStorage.setItem("pagePath", "Home");

  //    setIsLoggedOut(true)

  //   setOpen(false);
  // };

  const handleSettingsClick = () => {
    navigate("/user_settings");
    setOpen(false);
  };

  const handleProfileClick = () => {
    navigate("/profile");
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const clientId = localStorage.getItem("clientId");

      if (userId && clientId) {
        const url = `${FULL_API_BASE_URL}/logout-web?user_id=${encodeURIComponent(
          userId
        )}&client_id=${encodeURIComponent(clientId)}`;

        const res = await fetch(url, {
          method: "PUT", // if backend requires GET, change accordingly
          headers: {
            accept: "application/json",
          },
        });

        // Even if non-200, proceed with cleanup
        try {
          const data = await res.json();
          // Optionally, check data.status === 200
          // console.log("Logout API:", data);
        } catch (_) {
          // Ignore JSON parse issues
        }
      }
    } catch (e) {
      // Ignore network errors and proceed to cleanup
    } finally {
      // Clear all relevant localStorage items
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("userId");
      localStorage.removeItem("clientId");
      localStorage.removeItem("clientBranchId");
      localStorage.removeItem("pagePath");
      localStorage.removeItem("auth");

      // OAuth-related keys if present
      localStorage.removeItem("other");
      localStorage.removeItem("other_type");
      localStorage.removeItem("other_expires_in");

      // Any additional app-specific caches
      localStorage.removeItem("ipInfo");

      // Update UI state
      setAuthenticated(false);
      setIsLoggedOut(true);
      // Optional: reset page path preference
      localStorage.setItem("pagePath", "Home");
      setOpen(false);
    }
  };

  return (
    <div>
      <div className="avatar-menu-container" ref={menuRef}>
        <div
          className="menu-trigger"
          onClick={() => {
            setOpen(!open);
          }}
        >
          {gender_id == 1 ? (
            <div className="male_avatar"></div>
          ) : (
            <div className="female_avatar"></div>
          )}
          {/* <div className="male_avatar"></div>
          <div className="female_avatar"></div> */}
        </div>

        <div
          className={`dropdown-menu ${open ? "active" : "inactive"}`}
          style={{ zIndex: "11" }}
        >
          <div className="list">
            <li className="dropdownItem" onClick={handleProfileClick}>
              <div className="icon-DP-L profilesprite"></div>
              Profile
            </li>
            <li className="dropdownItem" onClick={handleSelect}>
              <div className="icon-DP-L privacysprite"></div>
              Privacy
            </li>
            <li className="dropdownItem" onClick={handleSettingsClick}>
              <div className="icon-DP-L settingsprite"></div>
              Settings
            </li>
            <li className="dropdownItem" onClick={handleLogout}>
              <div className="icon-DP-L logoutsprite"></div>
              Logout
            </li>
            {/* <li className="dropdownItem"> */}
            {/* <div className="icon logoutsprite"></div> */}
            {/* <img className="icon" src={logo} alt="" /> */}
            {/* Logout */}
            {/* </li> */}
          </div>
        </div>
      </div>
    </div>
  );
}

// function DropdownItem(props) {
//   return (
//     <li className="dropdownItem">
//       {/* <img src={props.img}></img> */}
//       <a>{props.text}</a>
//     </li>
//   );
// }

export default Dropdown;
